module.exports = __webpack_public_path__ + "static/media/logo-light.5f4e645f.svg";